import { Checkbox } from 'components/forms/Checkbox';
import React from 'react';
import styled from 'styled-components';
import { SecondaryText } from 'styles/theme_styles/text';

const ToggleWrapper = styled.label`
    border-radius: 5px;
    border: 1px solid transparent;
    padding: 0.8rem 0.5rem 0.5rem 1rem;
    column-gap: 1rem;

    cursor: pointer;
    transition: background-color 0.075s;
    &:hover {
        background-color: var(--action-hover);
    }
    &:active {
        background-color: var(--action-selected);
    }

    display: grid;
    grid-template-areas: 'checkbox title' 'nil description';
    .title {
        grid-area: title;
    }
    .checkbox {
        grid-area: checkbox;
        align-self: center;
        justify-self: center;
    }
    .description {
        grid-area: description;
    }
`;

const LabelSpan = styled.span`
    flex: 1;
    font-weight: 500;
`;

export type FeatureToggleProps = {
    id: string;
    label: string;
    description: React.ReactNode;
    checked: boolean | undefined;
    onChange: (value: boolean) => void;
};

export function FeatureToggle({
    id,
    label,
    description,
    checked,
    onChange,
}: FeatureToggleProps) {
    return (
        <ToggleWrapper htmlFor={id}>
            <LabelSpan className="title">{label}</LabelSpan>
            <Checkbox
                className="checkbox"
                id={id}
                checked={checked}
                onChange={(e) => onChange(e.value)}
                aria-describedby={`${id}Desc`}
            />
            <SecondaryText
                className="description"
                id={`${id}Desc`}
                style={{ marginBottom: '0.5rem' }}
            >
                {description}
            </SecondaryText>
        </ToggleWrapper>
    );
}
